import React, { useCallback } from 'react'

import { IconDisplay, IconDisplayProps } from 'src/refactor/blocks/IconDisplay'
import { ItemData } from 'src/context/results/types'
import { GetProvidersFilter } from 'src/api/types'
import { useSliceTemplate } from 'src/context/global'

import { PreferredBadge } from 'src/refactor/components/PreferredBadge'
import { TResultListItemProps } from './types'
import { ProviderResultListItemViewProviders } from './ProviderResultListItemViewProviders'
import {
  RliAddress,
  RliContainer,
  RliDistance,
  RliTitle,
} from './ResultListItem.styled'

type ItemProps = ItemData &
  TResultListItemProps & {
    id: string
    onClickExpand(id: string | null): void
    filterOptions: GetProvidersFilter
    specialtyCode?: string
    onExtend?(): void
    togglePopup(pin: string, forceState?: 'close' | 'open'): void
    isOpen?: boolean
  }

export const ProviderResultListItem = React.forwardRef<
  HTMLDivElement,
  ItemProps
>((props, ref) => {
  const {
    practiceName,
    distance,
    address1,
    fullAddress,
    style,
    phone,
    network,
    hasVirtualCare,
    isVirtualCareOnly,
    togglePopup,
    id,
    isOpen,
    isPreferred,
  } = props

  const onMouseEnter = useCallback(
    () => togglePopup(id, 'open'),
    [id, togglePopup]
  )
  const onMouseLeave = useCallback(
    () => togglePopup(id, 'close'),
    [id, togglePopup]
  )

  const isSliceTemplate = useSliceTemplate()

  const videoDisplayProps: IconDisplayProps = isSliceTemplate
    ? {
        icon: 'slice-video',
      }
    : {
        icon: 'video',
      }

  return (
    <RliContainer
      style={style}
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
      ref={ref}
      isOpen={isOpen}
      usePointerCursor
    >
      {isPreferred && <PreferredBadge />}
      <RliTitle role="heading" aria-level={2}>
        {practiceName}
      </RliTitle>
      {!isVirtualCareOnly && (
        <>
          <RliDistance>{distance} mi</RliDistance>

          <RliAddress>{address1}</RliAddress>
          <RliAddress>{fullAddress}</RliAddress>
        </>
      )}
      <div className="container__display">
        {isSliceTemplate && phone && (
          <IconDisplay icon="slice-phone">{phone}</IconDisplay>
        )}

        {hasVirtualCare && (
          <IconDisplay {...videoDisplayProps}>
            {isVirtualCareOnly ? 'Virtual care only' : 'Virtual care available'}
          </IconDisplay>
        )}
      </div>

      <ProviderResultListItemViewProviders
        {...props}
        isVirtualCareOnly={isVirtualCareOnly}
        practicePhone={phone}
        network={network as string}
      />
    </RliContainer>
  )
})
